/* Prints of the World theme behaviour: drawers, bag, product gallery, dispatch cut-off, load more. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Drawers ---------- */
  function openDrawer(dialog) {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }
  document.addEventListener('close', (e) => {
    if (e.target.matches('dialog.drawer')) document.documentElement.style.overflow = '';
  }, true);
  document.addEventListener('click', (e) => {
    const menuBtn = e.target.closest('[data-menu-open]');
    if (menuBtn) { openDrawer($('[data-menu-drawer]')); return; }
    const cartBtn = e.target.closest('[data-cart-open]');
    if (cartBtn) { e.preventDefault(); openDrawer($('[data-cart-drawer]')); return; }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { closeDrawer(closeBtn.closest('dialog')); return; }
    if (e.target.matches('dialog.drawer')) closeDrawer(e.target); /* backdrop click */
  });

  /* ---------- Bag ---------- */
  const cartDrawer = () => $('[data-cart-drawer]');

  function renderCart(sections) {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer-content]', doc);
    const current = $('[data-cart-drawer-content]');
    if (fresh && current) current.replaceWith(fresh);
    if (window.POTW.applyDispatch) window.POTW.applyDispatch();
    const countMatch = fresh && fresh.querySelector('.cart-drawer__title span');
    const count = countMatch ? parseInt(countMatch.textContent.replace(/\D/g, ''), 10) || 0 : 0;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      const link = el.closest('[data-cart-open]');
      if (link) link.setAttribute('aria-label', `Bag, ${count} items`);
    });
  }

  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-drawer] [data-line]');
    if (!btn) return;
    const drawer = cartDrawer();
    drawer.classList.add('is-updating');
    try {
      const data = await cartRequest(window.POTW.routes.cart_change, { line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) });
      renderCart(data.sections);
    } catch (err) {
      console.error(err);
    } finally {
      cartDrawer().classList.remove('is-updating');
    }
  });

  /* ---------- Product form ---------- */
  const form = $('[data-product-form]');
  if (form) {
    const qtyInput = $('[data-qty-input]', form);
    const submit = $('[data-atc]', form);
    const errorEl = $('[data-form-error]', form);
    $$('[data-qty-step]', form).forEach((b) => b.addEventListener('click', () => {
      const next = Math.min(20, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qtyStep)));
      qtyInput.value = next;
    }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submit.disabled) return;
      errorEl.hidden = true;
      submit.classList.add('is-loading');
      const label = submit.textContent;
      submit.textContent = 'Adding…';
      try {
        const id = Number(form.querySelector('[name="id"]').value);
        const quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        const data = await cartRequest(window.POTW.routes.cart_add, { items: [{ id, quantity }] });
        renderCart(data.sections);
        openDrawer(cartDrawer());
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        submit.classList.remove('is-loading');
        submit.textContent = label;
      }
    });

    /* Sticky bar on phones once the main button scrolls away */
    const bar = $('[data-sticky-atc]');
    if (bar && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-atc-button]', bar).tabIndex = show ? 0 : -1;
      });
      io.observe(submit);
      $('[data-sticky-atc-button]', bar).addEventListener('click', () => form.requestSubmit());
    }
  }

  /* ---------- Gallery ---------- */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const track = $('[data-gallery-track]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    const count = $('[data-gallery-count]', gallery);
    const slides = $$('[data-slide]', track);
    const setActive = (i) => {
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = `${i + 1} / ${slides.length}`;
    };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.dataset.thumb);
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth)));
    }, { passive: true });
  }

  /* ---------- Same-day dispatch messages (UK time) ----------
     [data-dispatch] elements render hidden and are shown from Monday 00:00 until the
     cut-off on Friday, then hidden over the weekend. Before the cut-off on a weekday,
     [data-dispatch-text] counts down to it. */
  function applyDispatch() {
    const els = $$('[data-dispatch]');
    if (!els.length) return;
    const hour = window.POTW.cutoffHour || 15;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
    }).formatToParts(new Date()).map((p) => [p.type, p.value]));
    const day = parts.weekday;
    const minsLeft = hour * 60 - (Number(parts.hour) * 60 + Number(parts.minute));
    const isWeekday = !['Sat', 'Sun'].includes(day);
    const show = isWeekday && !(day === 'Fri' && minsLeft <= 0);
    const cut = hour === 12 ? '12pm' : hour > 12 ? `${hour - 12}pm` : `${hour}am`;
    let text = `Order before <strong>${cut}</strong> for <strong>same-day dispatch</strong>`;
    if (isWeekday && minsLeft > 0) {
      const h = Math.floor(minsLeft / 60);
      const m = minsLeft % 60;
      const left = h > 0 ? `${h}h ${m}m` : `${m} min`;
      text = `Order in the next <strong>${left}</strong> for <strong>same-day dispatch</strong>`;
    }
    els.forEach((el) => {
      el.hidden = !show;
      const t = $('[data-dispatch-text]', el);
      if (t) t.innerHTML = text;
    });
  }
  window.POTW.applyDispatch = applyDispatch;
  applyDispatch();
  setInterval(applyDispatch, 60000);

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Brick wall hero ----------
     Frames hang on a brick wall that drags sideways. Selecting one brings it front and centre
     (the "spot" dialog) with details and Add to bag. Frames are cropped to their black edge
     from the crop box saved per product ("c": "left,top,right,bottom" as fractions). */
  const hero = $('[data-hero]');
  const wall = hero && $('[data-wall]', hero);
  if (wall) {
    const plane = $('[data-wall-plane]', wall);
    const dataEl = $('[data-wall-data]', hero);
    let lists = {};
    try { lists = JSON.parse(dataEl.textContent); } catch (e) { lists = {}; }
    const handles = Object.keys(lists);
    const allItems = () => {
      const out = [];
      const seen = new Set();
      const max = Math.max(0, ...handles.map((h) => lists[h].length));
      for (let i = 0; i < max; i++) handles.forEach((h) => {
        const it = lists[h][i];
        if (it && !seen.has(it.u)) { seen.add(it.u); out.push(it); }
      });
      return out;
    };
    const rand = (n) => { const x = Math.sin(n * 9301 + 49297) * 233280; return x - Math.floor(x); };

    function cropOf(it) {
      const c = (it.c || '').split(',').map(Number);
      if (c.length === 4 && c.every((n) => !Number.isNaN(n))) return { l: c[0], t: c[1], r: c[2], b: c[3], plain: false };
      return { l: 0, t: 0, r: 1, b: 1, plain: true };
    }
    function ratioOf(it) {
      const c = cropOf(it);
      return ((c.r - c.l) * it.w) / ((c.b - c.t) * it.h);
    }
    /* A box that shows only the frame part of the photo */
    function cropFrame(it, src, w, h) {
      const c = cropOf(it);
      const box = document.createElement('span');
      box.className = 'cropframe';
      box.style.width = `${w}px`;
      box.style.height = `${h}px`;
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.draggable = false;
      img.decoding = 'async';
      const cw = c.r - c.l;
      const ch = c.b - c.t;
      img.style.width = `${100 / cw}%`;
      img.style.height = `${100 / ch}%`;
      img.style.left = `${(-c.l / cw) * 100}%`;
      img.style.top = `${(-c.t / ch) * 100}%`;
      box.appendChild(img);
      return { box, img, plain: c.plain };
    }

    let items = [];
    let hangs = [];
    let x = 0;
    let minX = 0;
    let velocity = 0;
    let dragging = false;
    let moved = 0;
    let lastX = 0;
    let drift = reduceMotion ? 0 : -14; /* gentle idle movement until the visitor touches the wall */
    let tween = null;

    function hangFrame(it, k, w, h, left, top, copy) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hang';
      btn.dataset.k = k;
      if (copy) { btn.tabIndex = -1; btn.setAttribute('aria-hidden', 'true'); } else {
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('aria-label', `${it.t}, ${it.p}. See it up close`);
      }
      btn.style.left = `${Math.round(left)}px`;
      btn.style.top = `${Math.round(top)}px`;
      btn.style.width = `${Math.round(w)}px`;
      btn.style.height = `${Math.round(h)}px`;
      const f = cropFrame(it, it.s, Math.round(w), Math.round(h));
      f.img.loading = left < 1600 ? 'eager' : 'lazy';
      btn.appendChild(f.box);
      const tag = document.createElement('span');
      tag.className = 'hang__tag';
      tag.textContent = it.t;
      btn.appendChild(tag);
      btn.addEventListener('click', (e) => {
        if (moved > 6) { e.preventDefault(); return; }
        openSpot(k, btn);
      });
      plane.appendChild(btn);
      return btn;
    }

    /* Rows alternate portrait / landscape so every row is one shape and one size.
       Only prints with a measured black frame hang on the wall. */
    function layout(handle) {
      items = (handle === 'all' ? allItems() : (lists[handle] || [])).filter((it) => !cropOf(it).plain);
      const mobile = window.innerWidth < 990;
      const H = wall.clientHeight;
      const padY = mobile ? 16 : 26;
      const gap = mobile ? 26 : 40;
      const port = [];
      const land = [];
      items.forEach((it, k) => (ratioOf(it) < 1 ? port : land).push(k));
      let pattern = mobile ? ['p', 'l', 'p'] : ['p', 'l', 'p', 'l'];
      if (!port.length) pattern = pattern.map(() => 'l');
      if (!land.length) pattern = pattern.map(() => 'p');
      const weight = { p: 1.2, l: 0.8 };
      const unit = (H - padY * 2) / pattern.reduce((n, t) => n + weight[t], 0);
      const rows = pattern.map((type) => ({ type, h: unit * weight[type], ks: [] }));
      const byType = { p: rows.filter((r) => r.type === 'p'), l: rows.filter((r) => r.type === 'l') };
      port.forEach((k, i) => byType.p[i % byType.p.length].ks.push(k));
      land.forEach((k, i) => byType.l[i % byType.l.length].ks.push(k));
      const sizeOf = (k, row) => { const fh = row.h * (row.type === 'p' ? 0.86 : 0.8); return [fh * ratioOf(items[k]), fh]; };
      const rowWidth = (row) => row.ks.reduce((n, k) => n + sizeOf(k, row)[0] + gap, 0);
      const target = Math.max(wall.clientWidth * 1.15, ...rows.map(rowWidth));

      plane.replaceChildren();
      hangs = [];
      let y = padY;
      rows.forEach((row, r) => {
        let xPos = r % 2 ? gap * 1.6 : gap * 0.6;
        const cy = y + row.h / 2;
        let i = 0;
        while (row.ks.length && xPos < target) {
          const k = row.ks[i % row.ks.length];
          const [w, h] = sizeOf(k, row);
          const btn = hangFrame(items[k], k, w, h, xPos, cy - h / 2, i >= row.ks.length);
          if (i < row.ks.length) hangs[k] = btn;
          xPos += w + gap;
          i++;
        }
        y += row.h;
      });
      hangs = hangs.filter(Boolean);
      const planeW = target + gap * 2;
      plane.style.width = `${planeW}px`;
      plane.style.height = `${H}px`;
      const vw = wall.clientWidth;
      minX = Math.min(0, vw - planeW);
      x = minX === 0 ? (vw - planeW) / 2 : minX * 0.15;
      apply();
    }

    const scene = $('[data-wall-scene]', wall);
    function apply() {
      plane.style.transform = `translate3d(${x}px,0,0)`;
      if (scene) scene.style.backgroundPosition = `${x}px 0`; /* bricks move with the frames */
    }
    const clampX = (v) => (minX === 0 ? v : Math.max(minX, Math.min(0, v)));

    let last = performance.now();
    function frame(now) {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      if (tween) {
        const p = Math.min(1, (now - tween.start) / tween.dur);
        const e = 1 - Math.pow(1 - p, 3);
        x = tween.from + (tween.to - tween.from) * e;
        if (p >= 1) { const done = tween.done; tween = null; if (done) done(); }
        apply();
      } else if (!dragging) {
        if (Math.abs(velocity) > 1) { x += velocity * dt; velocity *= Math.pow(0.02, dt); }
        else if (drift) {
          x += drift * dt;
          if (x <= minX || x >= 0) drift = -drift;
        }
        const target = clampX(x);
        if (target !== x) { x += (target - x) * Math.min(1, dt * 10); velocity = 0; }
        apply();
      }
      requestAnimationFrame(frame);
    }

    const stopDrift = () => { drift = 0; };
    wall.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 || e.target.closest('.brickwall__nav')) return;
      dragging = true;
      moved = 0;
      velocity = 0;
      tween = null;
      lastX = e.clientX;
      stopDrift();
      wall.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - lastX;
      lastX = e.clientX;
      moved += Math.abs(dx);
      const over = x + dx > 0 || x + dx < minX;
      x += over ? dx * 0.35 : dx;
      velocity = dx * 60;
      apply();
    });
    const endDrag = () => { if (dragging) { dragging = false; wall.classList.remove('is-dragging'); } };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    wall.addEventListener('dragstart', (e) => e.preventDefault());
    wall.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); stopDrift(); x = clampX(x - e.deltaX); apply(); }
    }, { passive: false });
    $$('[data-wall-nudge]', wall).forEach((b) => b.addEventListener('click', () => {
      stopDrift();
      tween = { from: x, to: clampX(x + Number(b.dataset.wallNudge) * wall.clientWidth * 0.6), start: performance.now(), dur: 650 };
    }));
    wall.addEventListener('focusin', (e) => {
      stopDrift();
      const h = e.target.closest('.hang');
      if (!h) return;
      const left = h.offsetLeft + x;
      if (left < 40 || left + h.offsetWidth > wall.clientWidth - 40) {
        x = clampX(wall.clientWidth / 2 - (h.offsetLeft + h.offsetWidth / 2));
        apply();
      }
    });

    $$('[data-wall-tab]', hero).forEach((tab) => tab.addEventListener('click', () => {
      if (tab.classList.contains('is-active')) return;
      $$('[data-wall-tab]', hero).forEach((t) => {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-pressed', String(t === tab));
      });
      wall.classList.add('is-switching');
      setTimeout(() => { layout(tab.dataset.wallTab); wall.classList.remove('is-switching'); }, 250);
    }));

    let lastWide = window.innerWidth >= 990;
    window.addEventListener('resize', () => {
      const wide = window.innerWidth >= 990;
      if (wide !== lastWide) { lastWide = wide; layout($('[data-wall-tab].is-active', hero).dataset.wallTab); }
      else { minX = Math.min(0, wall.clientWidth - plane.offsetWidth); x = clampX(x); apply(); }
    });

    layout('all');
    requestAnimationFrame(frame);

    /* ---- Spotlight ---- */
    const spot = $('[data-spot]', hero);
    const spotFrame = $('[data-spot-frame]', spot);
    const spotAdd = $('[data-spot-add]', spot);
    const spotErr = $('[data-spot-error]', spot);
    let current = -1;

    function fillSpot(i) {
      const it = items[i];
      current = i;
      const mobile = window.innerWidth < 990;
      const maxW = mobile ? window.innerWidth - 40 : Math.min(window.innerWidth * 0.48, 760);
      const maxH = mobile ? window.innerHeight * 0.48 : Math.min(window.innerHeight * 0.8, 780);
      const ratio = ratioOf(it);
      let w = maxW;
      let h = w / ratio;
      if (h > maxH) { h = maxH; w = h * ratio; }
      const f = cropFrame(it, it.s, Math.round(w), Math.round(h));
      spotFrame.replaceChildren(f.box);
      spotFrame.classList.toggle('is-plain', f.plain);
      spotFrame.style.width = `${Math.round(w)}px`;
      spotFrame.style.height = `${Math.round(h)}px`;
      const big = new Image();
      big.onload = () => { if (current === i) f.img.src = it.l; };
      big.src = it.l;
      f.img.alt = `${it.t} A3 framed print`;
      $('[data-spot-eyebrow]', spot).textContent = it.e;
      $('[data-spot-title]', spot).textContent = it.t;
      $('[data-spot-price]', spot).textContent = it.p;
      $('[data-spot-link]', spot).href = it.u;
      spotAdd.disabled = !it.a;
      spotAdd.textContent = it.a ? 'Add to bag' : 'Sold out';
      spotErr.hidden = true;
      if (window.POTW.applyDispatch) window.POTW.applyDispatch();
    }

    function openSpot(i, fromEl) {
      stopDrift();
      fillSpot(i);
      spot.showModal();
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => spot.classList.add('is-open'));
      const src = fromEl && $('.cropframe', fromEl);
      if (src && !reduceMotion) {
        const a = src.getBoundingClientRect();
        const b = spotFrame.getBoundingClientRect();
        spotFrame.style.transition = 'none';
        spotFrame.style.transform = `translate(${a.left - b.left}px, ${a.top - b.top}px) scale(${a.width / b.width})`;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          spotFrame.style.transition = 'transform .5s cubic-bezier(.2, .8, .2, 1)';
          spotFrame.style.transform = '';
        }));
      }
    }
    function closeSpot() { spot.classList.remove('is-open'); spot.close(); }
    spot.addEventListener('close', () => { document.documentElement.style.overflow = ''; spot.classList.remove('is-open'); });
    $('[data-spot-close]', spot).addEventListener('click', closeSpot);
    spot.addEventListener('click', (e) => { if (e.target === spot || e.target.classList.contains('spot__inner') || e.target.classList.contains('spot__stage')) closeSpot(); });
    const step = (d) => {
      spotFrame.style.transition = 'none';
      spotFrame.style.transform = '';
      fillSpot((current + d + items.length) % items.length);
    };
    $$('[data-spot-step]', spot).forEach((b) => b.addEventListener('click', () => step(Number(b.dataset.spotStep))));
    spot.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    spotAdd.addEventListener('click', async () => {
      const it = items[current];
      spotAdd.classList.add('is-loading');
      spotAdd.textContent = 'Adding…';
      try {
        const data = await cartRequest(window.POTW.routes.cart_add, { items: [{ id: it.v, quantity: 1 }] });
        renderCart(data.sections);
        closeSpot();
        openDrawer(cartDrawer());
      } catch (err) {
        spotErr.textContent = err.message;
        spotErr.hidden = false;
      } finally {
        spotAdd.classList.remove('is-loading');
        spotAdd.textContent = 'Add to bag';
      }
    });

    /* ---- Pick me a legend: glide to a random frame, then bring it forward ---- */
    const pickBtn = $('[data-pick]', hero);
    if (pickBtn) pickBtn.addEventListener('click', () => {
      if (!hangs.length) return;
      stopDrift();
      const h = hangs[Math.floor(Math.random() * hangs.length)];
      const k = Number(h.dataset.k);
      const to = clampX(wall.clientWidth / 2 - (h.offsetLeft + h.offsetWidth / 2));
      wall.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      tween = {
        from: x, to, start: performance.now(), dur: reduceMotion ? 1 : 1100,
        done: () => {
          h.classList.add('is-picked');
          setTimeout(() => { h.classList.remove('is-picked'); openSpot(k, h); }, reduceMotion ? 0 : 900);
        },
      };
    });
  }

  /* ---------- Tilt: tiles lean towards the cursor ---------- */
  if (finePointer && !reduceMotion) {
    let tilted = null;
    const reset = (el) => { el.style.transform = ''; el.classList.remove('is-tilting'); };
    document.addEventListener('pointermove', (e) => {
      const tileEl = e.target.closest && e.target.closest('.card__tile');
      if (tilted && tilted !== tileEl) { reset(tilted); tilted = null; }
      if (!tileEl || (wall && wall.classList.contains('is-dragging'))) return;
      const r = tileEl.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      tileEl.style.transform = `perspective(700px) rotateX(${(-py * 9).toFixed(2)}deg) rotateY(${(px * 11).toFixed(2)}deg) translateY(-6px)`;
      tileEl.classList.add('is-tilting');
      tilted = tileEl;
    }, { passive: true });
    document.addEventListener('pointerleave', () => { if (tilted) reset(tilted); }, true);
  }

  /* ---------- Scroll reveal ---------- */
  const revealEls = $$('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const ro = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => ro.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Collection: sort and load more ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    more.classList.add('is-loading');
    try {
      const res = await fetch(more.href);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = $('[data-product-grid]');
      $$('[data-product-grid] > *', doc).forEach((card) => grid.appendChild(card));
      const fresh = $('[data-load-more-wrap]', doc);
      const wrap = $('[data-load-more-wrap]');
      if (fresh && wrap) wrap.replaceWith(fresh);
    } catch (err) {
      window.location.href = more.href;
    }
  });
})();
